import React, { Component } from "react";
import { Input, Button, Form } from "antd";
import { observer, inject } from "mobx-react";
import { IndexingServices } from "common/general";
// import "antd/dist/antd.css";

const FormItem = Form.Item;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class IndexerForm extends Component {
	checkIndexerBalance = event => {
		const keyPropertyName = event.target.dataset.key;
		const key = this.props.form.getFieldValue("indexer." + keyPropertyName);
		this.props.checkIndexerBalance(event.target.dataset.indexer, key);
	};
	render() {
		return (
			<div className="ant-table ant-table-small ant-table-scroll-position-left">
				<div className="ant-table-content">
					<div className="ant-table-body">
						<table className="">
							<colgroup>
								<col />
								<col />
								<col />
								<col />
							</colgroup>
							<thead className="ant-table-thead">
								<tr>
									<th className="">
										<span>Service</span>
									</th>
									<th className="">
										<span>API Key</span>
									</th>
									<th className="" style={{ width: 150 }}>
										<span>Action</span>
									</th>
									<th className="" style={{ width: 200 }}>
										<span>Status</span>
									</th>
								</tr>
							</thead>
							<tbody className="ant-table-tbody">
								{IndexingServices.map(service => {
									return (
										<tr
											key={service.key}
											className="ant-table-row  ant-table-row-level-0"
										>
											<td className="">
												<a href={service.link} target="_blank">
													{service.text}
												</a>
											</td>
											<td className="">
												<FormItem style={{ marginBottom: 0 }}>
													{this.props.form.getFieldDecorator(
														"indexer." + service.key
													)(<Input type="text" />)}
												</FormItem>
											</td>
											<td className="">
												<Button
													type="primary"
													data-indexer={service.name}
													data-key={service.key}
													onClick={this.checkIndexerBalance}
													loading={
														this.props.indexerStatus[service.name].validating
													}
												>
													Validate
												</Button>
											</td>
											<td className="">
												{this.props.indexerStatus[service.name].status}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		);
	}
}

@inject("rootStore")
@observer
class IndexerTab extends Component {
	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.formChanged(changedFields);
	};

	checkIndexerBalance = (indexer, key) => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.checkIndexerBalance(indexer, key);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;
		const options = optionsStore.stateForm;
		let indexer = {};

		IndexingServices.map(service => {
			indexer[service.key] = Form.createFormField(options.indexer[service.key]);
		});

		return {
			indexer: indexer
		};
	};

	getIndexerStatus = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		let indexerStatus = {};
		IndexingServices.map(service => {
			indexerStatus[service.name] = optionsStore.ui.indexerStatus[service.name];
		});
		return indexerStatus;
	};

	render() {
		let indexerStatus = this.getIndexerStatus();
		return (
			<IndexerForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
				indexerStatus={this.getIndexerStatus()}
				checkIndexerBalance={this.checkIndexerBalance}
			/>
		);
	}
}

export default IndexerTab;

// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">InstantLinkIndexer</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.instantLinkIndexerApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="InstantLinkIndexer"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">BackLinksIndexer</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.backLinksIndexerApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="BackLinksIndexer"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">EliteLinkIndexer</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.eliteLinkIndexerApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="EliteLinkIndexer"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">Indexification</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.indexificationApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="Indexification"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">LinkIndexr</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.linkIndexrApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="LinkIndexr"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">ExpressIndexer</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.expressIndexerApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="ExpressIndexer"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">Web 2.0 Indexer</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.web20IndexerApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="Web20Indexer"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">SpeedLink</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.speedLinkApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="SpeedLink"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">FastLinkIndexer</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.fastLinkIndexerApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="FastLinkIndexer"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">LinkProcessor</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.linkProcessorApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="LinkProcessor"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">LinkCentaur</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.linkCentaurApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="LinkCentaur"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
// <tr className="ant-table-row  ant-table-row-level-0">
// 	<td className="">LIndexed</td>
// 	<td className="">
// 		<FormItem style={{ marginBottom: 0 }}>
// 			{this.props.form.getFieldDecorator(
// 				"indexer.lIndexedApiKey"
// 			)(<Input type="text" />)}
// 		</FormItem>
// 	</td>
// 	<td className="">
// 		<Button
// 			type="primary"
// 			data-indexer="LIndexed"
// 			onClick={this.checkIndexerBalance}
// 		>
// 			Validate
// 		</Button>
// 	</td>
// 	<td className="">Valid</td>
// </tr>
